import { render, staticRenderFns } from "./FeaturedMembers.vue?vue&type=template&id=c5680ef8&"
import script from "./FeaturedMembers.vue?vue&type=script&lang=js&"
export * from "./FeaturedMembers.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedMembers.vue?vue&type=style&index=0&id=c5680ef8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports